import { g as i } from "../../utils-BOfnFgIH.js";
import { I as s } from "../../constants-DeVuDy8J.js";
import { createElementBlock as l, openBlock as r, normalizeClass as c, createElementVNode as t, createStaticVNode as n } from "vue";
import { _ as d } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const p = {
  name: "DtIconDialpadAnalyticsAi",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (o) => Object.keys(s).includes(o)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return s[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = i();
  }
}, f = ["aria-label", "data-qa", "aria-hidden"], _ = ["fill"], u = /* @__PURE__ */ t("circle", {
  cx: "12",
  cy: "12",
  r: "11.75",
  fill: "transparent",
  stroke: "#000",
  "stroke-opacity": ".1",
  "stroke-width": ".5"
}, null, -1), m = /* @__PURE__ */ t("path", {
  d: "M13.499 8.49c.357.302.707.623 1.047.963 2.964 2.964 4.328 6.47 2.853 7.947-.866.865-2.427.767-4.225-.112a.433.433 0 0 1 .38-.777c1.503.735 2.7.81 3.234.277 1-1-.19-4.061-2.853-6.723a15.829 15.829 0 0 0-.993-.913.432.432 0 0 1 .557-.661Zm1.958 4.408a.432.432 0 0 1 .05.61c-.294.346-.615.693-.96 1.039-2.965 2.963-6.471 4.327-7.946 2.852-.865-.865-.768-2.424.11-4.222a.432.432 0 1 1 .776.38c-.734 1.502-.808 2.698-.275 3.231 1 1 4.06-.19 6.723-2.852.33-.33.634-.66.912-.988a.433.433 0 0 1 .61-.05ZM10.822 6.71a.433.433 0 0 1-.38.778c-1.502-.734-2.697-.809-3.23-.276-1 1 .19 4.06 2.852 6.724.322.322.653.626.99.91a.433.433 0 0 1-.556.661 16.71 16.71 0 0 1-1.046-.96C6.49 11.583 5.125 8.076 6.601 6.6c.864-.865 2.423-.768 4.221.11Zm1.2 3.79a.246.246 0 0 1 .178.18l.18.747c.03.129.129.232.257.267l.66.185a.227.227 0 0 1-.009.44l-.624.15a.367.367 0 0 0-.273.278l-.186.852a.24.24 0 0 1-.469 0l-.185-.85a.366.366 0 0 0-.274-.28l-.647-.152a.227.227 0 0 1-.17-.274.227.227 0 0 1 .16-.168l.65-.182a.366.366 0 0 0 .256-.26l.198-.758a.245.245 0 0 1 .299-.175ZM17.4 6.6c.865.867.768 2.431-.111 4.232a.432.432 0 1 1-.777-.38c.736-1.506.81-2.706.277-3.24-1.001-1-4.062.19-6.724 2.853-.324.323-.63.657-.916.997a.432.432 0 1 1-.661-.557c.301-.359.625-.71.966-1.052 2.963-2.963 6.47-4.328 7.946-2.852Z",
  fill: "#fff"
}, null, -1), h = ["id"], g = /* @__PURE__ */ n('<stop stop-color="#471571"></stop><stop offset=".031" stop-color="#551B84"></stop><stop offset=".145" stop-color="#7C229E"></stop><stop offset=".237" stop-color="#9024A4"></stop><stop offset=".355" stop-color="#B02290"></stop><stop offset=".483" stop-color="#D32B86"></stop><stop offset=".603" stop-color="#E92F6F"></stop><stop offset=".701" stop-color="#F6484F"></stop><stop offset=".9" stop-color="#FB7328"></stop><stop offset=".973" stop-color="#F3960F"></stop><stop offset="1" stop-color="#F3960F"></stop>', 11), y = [
  g
];
function F(o, I, e, S, D, a) {
  return r(), l("svg", {
    "aria-label": e.ariaLabel,
    class: c([a.iconSizeClass, "d-icon d-icon--dialpad-analytics-ai"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Dialpad Analytics Ai",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    t("circle", {
      cx: "12",
      cy: "12",
      r: "12",
      fill: `url(#${o.uniqueID}a)`
    }, null, 8, _),
    u,
    m,
    t("defs", null, [
      t("linearGradient", {
        id: `${o.uniqueID}a`,
        x1: "0",
        y1: "0",
        x2: "24",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      }, y, 8, h)
    ])
  ], 10, f);
}
const B = /* @__PURE__ */ d(p, [["render", F]]);
export {
  B as default
};
//# sourceMappingURL=dialpad-analytics-ai.js.map
